import { FC } from 'react';

import { FormSelectAutocomplete } from '@argenta/react-ui';
import { t } from '@lingui/macro';

import { useLanguage } from '../../hooks/useLanguage';

import { PostalCodeInputProps } from './PostalCodeInput.types';
import { filterOption } from './PostalCodeInput.utils';
import zipcodesFr from './data/zipcodes.fr.json';
import zipcodesNl from './data/zipcodes.nl.json';

import './PostalCodeInput.styles.scss';

export const PostalCodeInput: FC<PostalCodeInputProps> = ({ name }) => {
  const { language } = useLanguage();

  // Render Methods
  // ---------------------------------------------------------------------- ?
  return (
    <FormSelectAutocomplete
      name={name}
      placeholder={t({ id: 'vacancies.search.postalCode.placeholder' })}
      noOptionsFoundText={t({ id: 'vacancies.search.postalCode.noOptionsMessage' })}
      isClearable
      options={language === 'nl' ? zipcodesNl.zipcodes : zipcodesFr.zipcodes}
      optionsAreEqual={(optionA, optionB) => optionA.value === optionB.value}
      filterOptions={filterOption}
    />
  );
};
